import { Grid } from "@mui/material";
import MakePaymentTable from "../../../components/Dashboard/MakePayment/MakePaymentTable";

const QualificationDetails = (_props) => {
  const { candidateData, className } = _props;
  return (
    <fieldset className={`${className}--fieldset`}>
      <legend className={`${className}--legend`}>
        Educational Qualifications Details
      </legend>
      {/* for web preview */}
      <div className="print-web">
        <Grid container spacing={1}>
          <Grid item lg={6} md={6} sm={6} xs={6}>
            <p className={`${className}--text`}>
              Do you have ten years teaching or working experience or working in
              a reputed industrial establishment or institute?
            </p>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={6}>
            <p className={`${className}--subText custom-rht`}>
              {String(candidateData?.is_ten_yr_exp_ind_est_ins_rep) === "1" &&
                "Yes"}
              {String(candidateData?.is_ten_yr_exp_ind_est_ins_rep) === "0" &&
                "No"}
              {String(candidateData?.is_ten_yr_exp_ind_est_ins_rep) !== "1" &&
                String(candidateData?.is_ten_yr_exp_ind_est_ins_rep) !== "0" &&
                "-"}
            </p>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <MakePaymentTable data={candidateData?.educationDetails} />
          </Grid>
        </Grid>
      </div>
      {/* for print preview */}
      <div className="print-view">
        <div className="print-details d-flex">
          <div className="w-80">
            <p className={`${className}--text`}>
              Do you have ten years teaching or working experience or working in
              a reputed industrial establishment or institute?
            </p>
          </div>
          <div className="w-20">
            <p className={`${className}--subText`}>
              {String(candidateData?.is_ten_yr_exp_ind_est_ins_rep) === "1" &&
                "Yes"}
              {String(candidateData?.is_ten_yr_exp_ind_est_ins_rep) === "0" &&
                "No"}
              {String(candidateData?.is_ten_yr_exp_ind_est_ins_rep) !== "1" &&
                String(candidateData?.is_ten_yr_exp_ind_est_ins_rep) !== "0" &&
                "-"}
            </p>
          </div>
        </div>
        <Grid container spacing={1}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <div className={`${className}--table`}>
              <MakePaymentTable data={candidateData?.educationDetails} />
            </div>
          </Grid>
        </Grid>
      </div>
    </fieldset>
  );
};

export default QualificationDetails;
